import React from 'react'

import { Provider } from 'react-redux'
import ReactDOM from 'react-dom/client'

import { initTheme, Theme } from '@interco/inter-ui'
import store from '@/store'
import { NotificationProvider } from '@interco/inter-ui/components/Notification'
import { SnackBarProvider } from '@interco/inter-ui/components/SnackBar'

import Router from './routes'
import { InterUIFonts } from './assets/fonts'

// Initialize Mock Service Worker if enabled
// Control via environment variable: REACT_APP_ENABLE_MSW
const shouldEnableMSW = process.env.REACT_APP_ENABLE_MSW !== 'false'

if (process.env.NODE_ENV === 'development' && shouldEnableMSW) {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const { worker } = require('./mocks/browser')
  worker.start({
    onUnhandledRequest: 'bypass',
  })
}

const AppWithControlPanel = () => {
  React.useEffect(() => {
    initTheme(Theme.PF)
    InterUIFonts()
  }, [])

  return (
    <Provider store={store}>
      <NotificationProvider>
        <SnackBarProvider>
          <Router />
        </SnackBarProvider>
      </NotificationProvider>
    </Provider>
  )
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(<AppWithControlPanel />)
export default AppWithControlPanel
